module.exports = __webpack_public_path__ + "img/shoeprint_splash.e7ad4887.jpg";